export default __webpack_public_path__ + "static/media/centric-software-logo-new.ce6a2d79.png";